import { Ifield } from '~/components/shared/genericSearch'
import { message } from '~/services/messages'

export const name = 'name'
export const documentValue = 'documentValue'
export const medicalRecord = 'medicalRecord'
export const birthDate = 'birthDate'
export const male = 'Masculino'
export const female = 'Feminino'
export const cpf = 'cpf'
export const documentClassificationCpf = 1
export const documentClassificationRg = 2
export const documentClassificationPassport = 3
export const biologicalSexMale = 1
export const biologicalSexFemale = 2
export const searchPatientsDefaultParams = {
  limit: '8',
  offset: '0'
}
export const PATIENT_BLOCKED_NAME = 'Paciente Restrito'
export const searchPatientSelect = [
  { label: message('messages.medical_record'), value: medicalRecord, inputMask: '9999999999' },
  { label: message('messages.name'), value: name },
  { label: message('messages.document'), value: documentValue, inputMask: '999.999.999-99' }
] as Ifield[]

export const sexOptions = [
  { value: biologicalSexFemale, label: message('messages.female') },
  { value: biologicalSexMale, label: message('messages.male') }
]

export const editPatientDocumentSelect = [
  { label: message('messages.document'), value: documentClassificationCpf, inputMask: '999.999.999-99' }
]
